import { useContext, useEffect, useState } from 'react';

import { Box, alpha, lighten, IconButton, styled, useTheme } from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import HeaderUserbox from './Userbox';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { PureLightTheme } from 'src/theme/schemes/PureLightTheme';
import { getClients } from 'src/api/clients';
import { Clients } from 'src/models/clients';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;     
        background: ${theme.colors.alpha.black[100]};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar, handleUserSelection } = useContext(SidebarContext);
  const theme = useTheme();

  const [clients, setClients] = useState<Clients[]>([]);

  const getClientsFromDb = async () => {
    const clientsResponse = await getClients();

    const clients = clientsResponse['clients'];
    if (Array.isArray(clients)) {
      setClients(clients);
    }
  };

  useEffect(() => {
    getClientsFromDb();
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    handleUserSelection(event.target.value as string);
  };

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(theme.colors.alpha.black[100], 0.2)}, 0px 5px 22px -4px ${alpha(theme.colors.alpha.black[100], 0.1)}`
      }}
    >
      <FormControl sx={{ minWidth: 120 }} size="small">
        <InputLabel id="demo-select-small-label" sx={{ color: `${PureLightTheme.colors.alpha.white[100]}`, pt: 0.5 }}>
          Clients
        </InputLabel>
        <Select
          labelId="demo-select-small-label"
          id="client-select"
          defaultValue={''}
          label="Clients"
          inputProps={{
            style: { color: `${PureLightTheme.colors.alpha.white[100]}` }
          }}
          sx={{ color: `${PureLightTheme.colors.alpha.white[100]}`, p: 0.5 }}
          onChange={handleChange}
        >
          {clients.map((client) => (
            <MenuItem key={client.clientId} value={client.clientId}>
              {client.clientId}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box display="flex" alignItems="center">
        <HeaderUserbox />
        <Box
          component="span"
          sx={{
            ml: 0,
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <IconButton color="info" onClick={toggleSidebar}>
            {!sidebarToggle ? <MenuTwoToneIcon fontSize="small" /> : <CloseTwoToneIcon fontSize="small" />}
          </IconButton>
        </Box>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
